<script>
    export let caption='';
    export let href='#';
</script>

<style>
    .nav-button{
        display: inline-block;
        width: 3rem;
        height: 2.5rem;
        font-size: 0.7rem;
        text-align: center;
        border: 1px solid transparent;
        border-radius: 40px;
        color: #333333;
        user-select: none;
    }
    a.nav-button{
        text-decoration: none;
        user-select: none;

    }
    a.nav-button:active{
        background-color: #ffff00;
        /* transition: background-color 0.2s; */
    }
    .nav-button>span{
        display: block;
        vertical-align: middle;
        text-align: center;
    }

</style>

<a class="nav-button" href={href}>
    <span>
        <slot></slot>
    </span>

    {#if caption!=''}
        <span>{caption}</span>
    {/if}
</a>
